import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { NavBar } from '../../components/layout/NavBar';
import './Objects.module.css'
import { Services } from '@/services/services';
import { Object, SimpleObject } from '@/services/model/object';


export const ObjectsPage = ({services}: {services: Services}) => {
  const navigate = useNavigate();
  const [list, setList] = useState<SimpleObject[]>()

  useEffect(() => {
    services.objects.list().then((data) => setList(data || []))
  }, []);

  function renderRow(row: SimpleObject) {
    return (<li onClick={()=>navigate('/service/objects/'+row.imei)}>
      {row.name} ({row.imei})
    </li>)
  }

  return (
    <div>
      <NavBar services={services} />
      <section className='objects-page content-body'>
        <h2>Objects</h2>
        {list !== null ? list?.map((row) => renderRow(row)) : <div className='spinner'></div>}
      </section>

    </div>
  );
};
